import React from 'react';
import ImageGallery from 'react-image-gallery';
import noImage from './images/no-image.png';
import 'react-image-gallery/styles/css/image-gallery.css';
import './ProductGallery.css';

function ProductGallery({product, disabled, onSlide}) {
    const getImages = () => {
        if (product && product.hasGallery()) {
            if (disabled) {
                const item = product.multimedia.gallery[0];
                return [{
                    original: item.l,
                    thumbnail: undefined,
                    loading: 'eager',
                    bulletClass : 'product-gallery_bullet'
                }];
            }
            return product.multimedia.gallery.map((item) => ({
                original: item.l,
                thumbnail: undefined,
                loading: 'eager',
                bulletClass : 'product-gallery_bullet'
            }));
        } else return [];
    };

    const handleSlide = (index) => {
        if (onSlide) {
            const images = getImages();
            const image = images[index].original;
            onSlide(index, image);
        }
    };

    return (
        <div className={`product-gallery${disabled ? ' disabled' : ''}`}>
            <ImageGallery
                items={getImages()}
                infinite={true}
                lazyLoad={false}
                showNav={!disabled}
                showThumbnails={false}
                showFullscreenButton={false}
                showPlayButton={false}
                showBullets={!disabled}
                showIndex={false}
                autoPlay={false}
                disableKeyDown={disabled}
                disableSwipe={disabled}
                onErrorImageURL={noImage}
                startIndex={0}
                onSlide={handleSlide}
            />
        </div>
    );
}

export default ProductGallery;